export enum FontSize {
  body = '16px',
  title = '18px',
}
